import { RowPlanDto } from "@/dtos";
import { Plan } from "@/entities";
import { formatToCurrency } from "@/helpers/utilities";

export const formatRowPlanDto = (plans: Plan[]): RowPlanDto[] => {
    return plans.map(x => {
        const row: RowPlanDto = {
            ...x,
            min_limit_label:  formatToCurrency(x.min_limit),
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}